import { loadClient, type MatchesCouponType } from '@cx-modules/matches-coupon';

export let MatchesCoupon: MatchesCouponType;

export const loadMatchesCouponForClient = async () => {
	const response = await loadClient(ENV.CX_COMPONENTS_URL);

	MatchesCoupon = response.Component;

	return response;
};
